import Grid from '@mui/material/Grid';

import { useGiftOrdersHeaders } from 'modules/support-gift-orders/hooks/gift-orders-header/useGiftOrdersHeader';

import GiftOrdersHeaderButtons from './GiftOrdersHeaderButtons';
import GiftOrdersHeaderDatePickers from './GiftOrdersHeaderDatePickers';
import GiftOrdersHeaderTextField from './GiftOrdersHeaderTextFields';

const GiftOrdersHeader = ({ onSearch }) => {
  // Hook propio de la funcionalidad del encabezado (filtros)
  const { handleSubmit, onSubmit } = useGiftOrdersHeaders();
  const handleFormSubmit = (data) => {
    onSubmit(data);
    if (onSearch) onSearch(); // <-- Aquí marcas la búsqueda
  };
  return (
    <>
      <h1>Listado de regalos</h1>

      <Grid item size={{ xs: 12 }} className={'filters-container'}>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <Grid container>
            <GiftOrdersHeaderDatePickers />

            <GiftOrdersHeaderTextField />

            <GiftOrdersHeaderButtons />
          </Grid>
        </form>
      </Grid>
    </>
  );
};

export default GiftOrdersHeader;
